import React from "react";

import {
  ApiKeysTab,
  DriverAppTab,
  RouteOptimizationTab,
  PricingTab,
  PayrollTab,
  ClosedDaysTab,
} from "./components";

export interface SettingsTab {
  path: string;
  label: string;
  element: React.ReactNode;
}

// Single source of truth for the vertical rail (SettingsView) and the nested
// routes (App.tsx). Add a tab = one entry here + one placeholder component.
export const SETTINGS_TABS: SettingsTab[] = [
  { path: "api-keys", label: "API Keys", element: <ApiKeysTab /> },
  {
    path: "driver-app",
    label: "Driver App",
    element: <DriverAppTab />,
  },
  {
    path: "route-optimization",
    label: "Route Optimization",
    element: <RouteOptimizationTab />,
  },
  {
    path: "pricing",
    label: "Pricing",
    element: <PricingTab />,
  },
  {
    path: "payroll",
    label: "Payroll",
    element: <PayrollTab />,
  },
  {
    path: "closed-days",
    label: "Closed Days",
    element: <ClosedDaysTab />,
  },
];
